<template>
<v-app id="inspire">

<vue-header-admin></vue-header-admin>
<v-main>
   <v-container>
        <v-row
            align="center"
            style="margin-bottom: 80px!important;"
            justify="center"
          >
            <v-col cols="12" md="12">
               <v-card class="card-shadow border-radius-xl mt-2" id="basic" style="margin-bottom: 100px;">
                <v-card-text style="margin-bottom: -30px;">
                 <v-form
                        ref="form1"
                        v-model="validGeneral"
                        lazy-validation
                    >
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >                    
                    <h5 class="text-h4 font-weight-bold text-typo">Edit Client</h5>
                    </v-col>
                    
                 
                    <v-col

                      cols="12"
                      md="6"
                    >
                     <v-text-field
                        id="name"
                        name="name"
                        label="First Name"
                        :rules="rules"
                        class="font-size-input input-style"
                        width="300px"
                        ref="name"
                        v-model="client.first_name"
                        />

                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                     <v-text-field
                        id="name"
                        :rules="rules"
                        name="name"
                        class="font-size-input input-style"
                        label="Last Name"
                        width="300px"
                        ref="name"
                        v-model="client.last_name"
                        />

                    </v-col>
                    
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="Email"
                          :rules="emailRules"
                          class="font-size-input input-style"
                          :disabled="client.is_email"
                          v-model="client.email"
                    ></v-text-field>
                      </v-col>
                   
                      
                      
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          v-model="client.phone_m"
                          class="font-size-input input-style"
                          v-mask="'(###) ###-####'"
                          :rules="rules"
                          label="Phone (Mobile)"
                    ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12"  sm="12" md="12" lg="12" style="margin-top:-35px;" >
                          <vuetify-google-autocomplete
                                  id="map"
                                  v-model="address"
                                  class="font-size-input input-style"
                                  placeholder="Enter a location"
                                  v-on:placechanged="getAddressData"
                                  country="us"
                                  label="Address"
                              ></vuetify-google-autocomplete>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          v-model="client.city"
                          class="font-size-input input-style"
                          label="City"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-select
                          :items="stateOptions"
                          item-text="name"
                          class="font-size-input input-style"
                          item-value="abbreviation"
                          placeholder="Select State"
                          v-model="client.state"
                          label="State"
                    ></v-select>
                      </v-col> -->
                      <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Business Name"
                              v-model="client.business_name"
                              class="font-size-input input-style"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Business Address"
                              v-model="client.business_address"
                              class="font-size-input input-style"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Instagram"
                              v-model="client.instagram"
                              class="font-size-input input-style"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Facebook"
                              v-model="client.facebook"
                              class="font-size-input input-style"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Tiktok"
                              v-model="client.linkedin"
                              class="font-size-input input-style"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Youtube Channel"
                              v-model="client.youtube"
                              class="font-size-input input-style"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" style="margin-top:-35px;">
                            <v-text-field
                              color="#e91e63"
                              label="Website"
                              v-model="client.website"
                              class="font-size-input input-style"
                            >
                            </v-text-field> 
                          </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          v-model="client.zip"
                          class="font-size-input input-style"
                          label="Zip"
                    ></v-text-field>
                      </v-col>

                      <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;">
                                <span >Date of Birth<span class="required_span"> *</span></span>
                                <v-text-field
                                v-model="dob"
                                width="300px"
                                outlined
                                placeholder="MM/DD/YYYY"
                                v-mask="'##/##/####'"
                                ref="dob"
                                class="font-size-input input-style"
                                :suffix="'Age '+ age"
                                :rules="rules_name"
                            >
                            
                            </v-text-field>
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;">
                                <span >SSN<span class="required_span"> *</span></span>
                                <v-text-field
                                :rules="rules_name"
                                outlined
                                v-mask="'###-##-####'"
                                v-model="client.ssn"
                                required
                                class="font-size-input input-style"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;">
                                <span >Driver's License Number</span>
                                <v-text-field
                                outlined
                                v-model="client.driving_license_number"
                                required
                                class="font-size-input input-style"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;">
                                <span >Driver's License State</span>
                             
                                <v-select
                                    :items="stateOptions"
                                    item-text="name"
                                    item-value="abbreviation"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Select State"
                                    v-model="client.driving_license_state"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;">
                                <span >Driver's License Issue Date</span>
                                
                                <v-menu
                                    ref="menu2"
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :return-value.sync="client.driving_license_issue_date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                        v-model="client.driving_license_issue_date"
                                        append-icon="fa-calendar"
                                        readonly
                                        v-bind="attrs"
                                        class="font-size-input input-style"
                                        outlined
                                        clearable
                                        v-on="on"
                                        @click:clear="client.driving_license_issue_date = null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="client.driving_license_issue_date"
                                        scrollable
                                        color="green lighten-1"
                                        :min="minDate"
                                        header-color="green lighten-1"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                        text
                                        color="primary"
                                        @click="menu2 = false"
                                        >
                                        Cancel
                                        </v-btn>
                                        <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu2.save(client.driving_license_issue_date)"
                                        >
                                        OK
                                        </v-btn>
                                    </v-date-picker>
                                    </v-menu>
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;">
                                <span >Driver's License Expiry Date</span>

                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="client.driving_license_expiry_date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                        v-model="client.driving_license_expiry_date"
                                        append-icon="fa-calendar"
                                        readonly
                                        v-bind="attrs"
                                        class="font-size-input input-style"
                                        outlined
                                        clearable
                                        v-on="on"
                                        @click:clear="client.driving_license_expiry_date = null"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="client.driving_license_expiry_date"
                                        scrollable
                                        color="green lighten-1"
                                        :min="minDate"
                                        header-color="green lighten-1"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                        >
                                        Cancel
                                        </v-btn>
                                        <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(client.driving_license_expiry_date)"
                                        >
                                        OK
                                        </v-btn>
                                    </v-date-picker>
                                    </v-menu>
                            </v-col>
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;">
                                <p class="text-h6"> Residential Information </p>
                            </v-col>
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -25px;">
                                <span >Street Address<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.address_1"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >City<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.city"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >State<span class="required_span"> *</span></span>
                                <v-select
                                    :items="stateOptions"
                                    item-text="name"
                                    item-value="abbreviation"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Select State"
                                    v-model="client.state"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col> 
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Zip Code<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.zip"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Housing Type<span class="required_span"> *</span></span>
                                <v-select
                                    :items="['Rent','Own','Other']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="client.housing_type"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Monthly Rent/Mortgage Amount<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.monthly_rent_mortgage_amount"
                                    />
                            </v-col>
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >Years at Address<span class="required_span"> *</span></span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="client.years_at_address"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >&nbsp;</span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="client.months_at_address"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  sm="12" md="12" lg="12" style="margin-top:-55px;" >
                                <v-checkbox
                                    style=""
                                    v-model="client.checkbox_previous_address"
                                    :label="`Add previous address`"
                                    ></v-checkbox>
                            </v-col>

                            
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;" v-if="client.checkbox_previous_address">
                                <p class="text-h6"> Previous Address </p>
                            </v-col>
                            <v-col cols="12" v-if="client.checkbox_previous_address">
                            <v-row v-for="(address, index) in client.previous_address" :key="index">
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -25px;">
                                <span >Street Address<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="address.address_1"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >City<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="address.city"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >State<span class="required_span"> *</span></span>
                                <v-select
                                    :items="stateOptions"
                                    item-text="name"
                                    item-value="abbreviation"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Select State"
                                    v-model="address.state"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col> 
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Zip Code<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="address.zip"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Housing Type<span class="required_span"> *</span></span>
                                <v-select
                                    :items="['Rent','Own','Other']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="address.housing_type"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Monthly Rent/Mortgage Amount<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="address.monthly_rent_mortgage_amount"
                                    />
                            </v-col>
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >Years at Address<span class="required_span"> *</span></span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="address.years_at_address"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >&nbsp;</span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="address.months_at_address"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;">
                            <v-btn
                                text
                                style="margin-left: -15px;"
                                color="blue"
                                    @click="addPreviousAddress"
                            >
                                Add more
                            </v-btn>
                            <v-btn
                                text
                                v-if="client.previous_address.length > 1"
                                color="red"
                                    @click="removePreviousAddress(index)"
                            >
                                Remove
                            </v-btn>
                        </v-col>
                            </v-row>
                        </v-col>
                       <!-- Employment Information -->
                       <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;">
                                <p class="text-h6"> Employment Information </p>
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Employer Name<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.employer_name"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Title/Position<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.employment_position"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Employer Phone Number<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    append-icon="fa-phone"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.employment_employer_phone"
                                    />
                            </v-col> 
                            
                            <v-col cols="12"  md="8" lg="8" style="margin-top: -35px;">
                                <span >Monthly Gross Income<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.employment_income"
                                    />
                            </v-col>
                         
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >Years at Job<span class="required_span"> *</span></span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="client.employment_years_at_job"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >&nbsp;</span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="client.employment_months_at_job"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  sm="12" md="12" lg="12" style="margin-top:-55px;" >
                                <v-checkbox
                                    style=""
                                    v-model="client.checkbox_previous_employment"
                                    :label="`Previous employment`"
                                    ></v-checkbox>
                            </v-col>

                            
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;" v-if="client.checkbox_previous_employment">
                                <p class="text-h6"> Previous Employment </p>
                            </v-col>
                            <v-col cols="12" v-if="client.checkbox_previous_employment">
                            <v-row v-for="(job, index) in client.previous_employment" :key="index">
                                <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Employer Name<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="job.employer_name"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Title/Position<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="job.employment_position"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;">
                                <span >Employer Phone Number<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="job.employment_employer_phone"
                                    />
                            </v-col> 
                            
                            <v-col cols="12"  md="8" lg="8" style="margin-top: -35px;">
                                <span >Monthly Gross Income<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="job.employment_income"
                                    />
                            </v-col>
                         
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >Years at Job<span class="required_span"> *</span></span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="job.employment_years_at_job"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="2" lg="2" style="margin-top: -35px;">
                                <span >&nbsp;</span>
                                <v-select
                                    :items="['0','1','2','3','4','5','6','7','8','9','10','11']"
                                    height="40px"
                                    class="font-size-input input-style"
                                    placeholder="Housing Type"
                                    v-model="job.employment_months_at_job"
                                    :rules="rules_name"
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;margin-bottom: 20px;">
                            <v-btn
                                text
                                style="margin-left: -15px;"
                                color="blue"
                                    @click="addPreviousEmployment"
                            >
                                Add more
                            </v-btn>
                            <v-btn
                                text
                                v-if="client.previous_employment.length > 1"
                                color="red"
                                    @click="removePreviousEmployment(index)"
                            >
                                Remove
                            </v-btn>
                        </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12"  sm="12" md="12" lg="12" style="margin-top:-55px;" >
                                <v-checkbox
                                    style=""
                                    color="blue"
                                    v-model="client.checkbox_trade_in"
                                    :label="`Add Trade-in?`"
                                    ></v-checkbox>
                            </v-col>
                            <v-col cols="12"  md="12" lg="12" style="margin-top: -35px;" v-if="client.checkbox_trade_in">
                                <p class="text-h6" > Trade-in </p>
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;" v-if="client.checkbox_trade_in">
                                <span >VIN<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.trade_in_vin"
                                    />
                            </v-col>
                            <v-col cols="12"  md="6" lg="6" style="margin-top: -35px;" v-if="client.checkbox_trade_in">
                                <span >Mileage<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.trade_in_mileage"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;" v-if="client.checkbox_trade_in">
                                <span >Year<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.trade_in_year"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;" v-if="client.checkbox_trade_in">
                                <span >Make<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.trade_in_make"
                                    />
                            </v-col>
                            <v-col cols="12"  md="4" lg="4" style="margin-top: -35px;" v-if="client.checkbox_trade_in">
                                <span >Model<span class="required_span"> *</span></span>
                                <v-text-field
                                    id="name"
                                    name="name"
                                    class="font-size-input input-style"
                                    width="300px"
                                    :rules="rules_name"
                                    outlined
                                    ref="name"

                                    v-model="client.trade_in_model"
                                    />
                            </v-col>
                     
                      <v-col cols="12"  sm="6" md="6" lg="6"  >
                     <p for="my-file">Profile Picture</p>
                      <v-btn
                              type="button"
                              color="blue"
                              small
                              :loading="loadingUpload"
                              class="
                                font-weight-bolder
                                btn-default
                                mb-5
                                px-8
                                ms-auto
                              "
                              @click="changeTrigger = true"
                            >
                              Select profile picture
                            </v-btn>
                        <avatar-cropper
                          :upload-handler="handleUploaded"
                          :output-mime="cropperOutputMime"
                          v-model="changeTrigger"
                          />

                      <div class="border p-2 mt-3">
                      <p>Preview Here:</p>
                      <template >
                        <v-img contain v-if="!preview" src="@/assets/img/avatar.png" class="img-fluid" />
                        <v-img contain v-else :src="preview" class="img-fluid" />
                      </template>
                    </div>
                      </v-col>

                     

                    <!-- Voice Agent Section -->
                    <v-col cols="12" md="12" class="mt-5">
                      <v-divider class="mb-4"></v-divider>
                      <h6 class="text-h6 font-weight-bold text-typo mb-4">Voice Agent Settings</h6>

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-card outlined class="pa-4">
                            <div class="d-flex align-center mb-3">
                              <span class="font-weight-bold">Voice Agent Status</span>
                            </div>

                            <div v-if="!voiceAgent.has_voice_agent" class="text-center">
                              <p class="text-body-2 mb-3">No voice agent configured for this client</p>
                              <v-btn
                                color="blue"
                                dark
                                @click="createVoiceAgent"
                                :loading="voiceAgentLoading"
                                small
                              >
                                <v-icon left class="material-icons-round">add</v-icon>
                                Create Voice Agent
                              </v-btn>
                            </div>

                            <div v-else>
                              <div class="mb-3">
                                <v-chip
                                  :color="voiceAgent.voice_agent_enabled ? 'green' : 'red'"
                                  small
                                  dark
                                  class="mb-2"
                                >
                                  {{ voiceAgent.voice_agent_enabled ? 'Active' : 'Inactive' }}
                                </v-chip>
                                <p class="text-caption mb-1">Agent ID: {{ voiceAgent.retell_agent_id }}</p>
                                <p class="text-caption mb-1" v-if="voiceAgent.retell_phone_number">
                                  Phone: {{ voiceAgent.retell_phone_number }}
                                </p>
                                <p class="text-caption" v-if="voiceAgent.voice_agent_created_at">
                                  Created: {{ formatDate(voiceAgent.voice_agent_created_at) }}
                                </p>
                              </div>

                              <div class="d-flex flex-wrap gap-2">
                                <v-btn
                                  :color="voiceAgent.voice_agent_enabled ? 'red' : 'green'"
                                  @click="toggleVoiceAgent"
                                  dark
                                  class="mr-2"
                                  :loading="voiceAgentLoading"
                                  small
                                >
                                  {{ voiceAgent.voice_agent_enabled ? 'Disable' : 'Enable' }}
                                </v-btn>

                                <v-btn
                                  v-if="!voiceAgent.retell_phone_number"
                                  color="grey"
                                  dark
                                  class="mr-2"
                                  @click="assignPhoneNumber"
                                  :loading="phoneNumberLoading"
                                  small
                                >
                                  Assign Phone
                                </v-btn>

                                <v-btn
                                  color="red"
                                  @click="deleteVoiceAgent"
                                  :loading="voiceAgentLoading"
                                  small
                                  dark
                                  outlined
                                >
                                  <v-icon left class="material-icons-round">delete</v-icon>
                                  Delete
                                </v-btn>
                              </div>
                            </div>
                          </v-card>
                        </v-col>

                        <v-col cols="12" md="6" v-if="voiceAgent.has_voice_agent">
                          <v-card outlined class="pa-4">
                            <div class="d-flex align-center mb-3">
                              <v-icon color="primary" class="mr-2">mdi-script-text</v-icon>
                              <span class="font-weight-bold">Agent Prompt</span>
                            </div>

                            <v-textarea
                              v-model="voiceAgentPrompt"
                              label="Voice Agent Instructions"
                              rows="8"
                              outlined
                              dense
                              class="font-size-input"
                              placeholder="Enter instructions for the voice agent..."
                            ></v-textarea>

                            <v-btn
                              color="blue"
                              @click="updateVoiceAgentPrompt"
                              :loading="promptLoading"
                              small
                              :disabled="!voiceAgentPrompt || voiceAgentPrompt === voiceAgent.voice_agent_prompt"
                            >
                              Update Prompt
                            </v-btn>
                          </v-card>
                        </v-col>
                         <!-- Uploaded Voice Section -->
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p>Uploaded Voice File</p>
                        <div v-if="clientVoiceFile" class="border p-3 mt-3">
                          <div class="d-flex align-center mb-2">
                            <v-icon class="mr-2 material-icons-round" color="orange">audiotrack</v-icon>
                            <div class="flex-grow-1">
                              <p class="text-body-2 mb-1 font-weight-medium">{{ clientVoiceFile.name }}</p>
                              <p class="text-caption mb-0">
                                Uploaded: {{ formatDate(clientVoiceFile.uploaded_at) }}
                                <span v-if="clientVoiceFile.file_size_mb"> • {{ clientVoiceFile.file_size_mb }} MB</span>
                              </p>
                            </div>
                            <v-chip small color="orange" text-color="white">
                              {{ clientVoiceFile.status }}
                            </v-chip>
                          </div>

                          <div v-if="clientVoiceFile.download_url" class="mb-2">
                            <audio controls :src="clientVoiceFile.download_url" style="width: 100%;"></audio>
                          </div>

                          <v-btn
                            color="orange"
                            outlined
                            small
                            @click="downloadClientVoice"
                            :disabled="!clientVoiceFile.download_url"
                            class="ml-2 mb-2"
                          >
                            <v-icon left small class="material-icons-round">download</v-icon>
                            Download Voice
                          </v-btn>
                        </div>
                        <div v-else class="border p-3 mt-3 text-center">
                          <v-icon size="48" color="grey lighten-2" class="material-icons-round">mic_off</v-icon>
                          <p class="text-caption mt-2 mb-0">No voice file uploaded</p>
                        </div>
                      </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                    cols="12"
                    md="12"
                    >
                     <v-card-actions class="justify-center ">
                  <v-row>
                    <v-col>
                      <v-btn
                          outlined
                            :ripple="false"
                            elevation="0"
                            :x-small=" this.$vuetify.breakpoint.xs ? true : false "
                          color="#4CAF50"
                          @click="$router.push('/admin/client-profile-detail/'+$route.params.id)"
                            class="
                              font-weight-bolder
                              btn-primary
                              py-5
                              float-right
                              px-6
                              ms-2
                            "
                            
                          >
                            Back
                          </v-btn>
                      <v-btn
                        color="#4CAF50"
                        large
                        :disabled="!validGeneral"
                        :loading="loading"
                        @click="saveProfile"
                        class="
                        float-right
                          font-weight-bolder
                          btn-default
                          mb-5
                          px-8
                          ms-auto
                        "
                        
                      >
                        Save
                      </v-btn>
                      
                      </v-col>
                    </v-row>
                </v-card-actions>
                    
                    </v-col>

                    
                  </v-row>
                 </v-form>
                </v-card-text>
                <!-- <v-card-actions class="justify-center ">
                  <v-btn
                    tile  dark
                    style="height: 49px;width:95px;"
                    color="primary"
                    class="mb-10"
                    @click="saveProfile"
                  >Save</v-btn>
                </v-card-actions> -->
              </v-card>
            </v-col>
          </v-row>
    </v-container>
     <vue-footer-admin></vue-footer-admin>
     </v-main>
</v-app>

</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import DateDropdown from 'vue-date-dropdown'
import moment from 'moment'
import ClipLoader from 'vue-spinner/src/PulseLoader.vue';
import AvatarCropper from 'vue-avatar-cropper'
export default {
components: {
      VueTelInput,DateDropdown,AvatarCropper,
      'RotateLoader': ClipLoader
  },
  data () {

      return {
        fname : '',
        lname : '',
        email : '',
        dob:'',
        age:0,
        changeTrigger: false,
        name:'',
        phone:'123456',
        password : '',
        is_admin:0,
        cropperOutputMime: '',
        confpassword : '',
        role : '',
        companyname : '',
        sector : '',
        no_of_employee : '',
        existOption: ["New","Existing"],
        showPassword : false,
        phoneFlag:0,
        emailFlag:0,
        country :'',
        otp_email:'',
        otp_phone:'',
        stateOptions: [
                { name: 'ALABAMA', abbreviation: 'AL'},
                { name: 'ALASKA', abbreviation: 'AK'},
                { name: 'AMERICAN SAMOA', abbreviation: 'AS'},
                { name: 'ARIZONA', abbreviation: 'AZ'},
                { name: 'ARKANSAS', abbreviation: 'AR'},
                { name: 'CALIFORNIA', abbreviation: 'CA'},
                { name: 'COLORADO', abbreviation: 'CO'},
                { name: 'CONNECTICUT', abbreviation: 'CT'},
                { name: 'DELAWARE', abbreviation: 'DE'},
                { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
                { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM'},
                { name: 'FLORIDA', abbreviation: 'FL'},
                { name: 'GEORGIA', abbreviation: 'GA'},
                { name: 'GUAM', abbreviation: 'GU'},
                { name: 'HAWAII', abbreviation: 'HI'},
                { name: 'IDAHO', abbreviation: 'ID'},
                { name: 'ILLINOIS', abbreviation: 'IL'},
                { name: 'INDIANA', abbreviation: 'IN'},
                { name: 'IOWA', abbreviation: 'IA'},
                { name: 'KANSAS', abbreviation: 'KS'},
                { name: 'KENTUCKY', abbreviation: 'KY'},
                { name: 'LOUISIANA', abbreviation: 'LA'},
                { name: 'MAINE', abbreviation: 'ME'},
                { name: 'MARSHALL ISLANDS', abbreviation: 'MH'},
                { name: 'MARYLAND', abbreviation: 'MD'},
                { name: 'MASSACHUSETTS', abbreviation: 'MA'},
                { name: 'MICHIGAN', abbreviation: 'MI'},
                { name: 'MINNESOTA', abbreviation: 'MN'},
                { name: 'MISSISSIPPI', abbreviation: 'MS'},
                { name: 'MISSOURI', abbreviation: 'MO'},
                { name: 'MONTANA', abbreviation: 'MT'},
                { name: 'NEBRASKA', abbreviation: 'NE'},
                { name: 'NEVADA', abbreviation: 'NV'},
                { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
                { name: 'NEW JERSEY', abbreviation: 'NJ'},
                { name: 'NEW MEXICO', abbreviation: 'NM'},
                { name: 'NEW YORK', abbreviation: 'NY'},
                { name: 'NORTH CAROLINA', abbreviation: 'NC'},
                { name: 'NORTH DAKOTA', abbreviation: 'ND'},
                { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP'},
                { name: 'OHIO', abbreviation: 'OH'},
                { name: 'OKLAHOMA', abbreviation: 'OK'},
                { name: 'OREGON', abbreviation: 'OR'},
                { name: 'PALAU', abbreviation: 'PW'},
                { name: 'PENNSYLVANIA', abbreviation: 'PA'},
                { name: 'PUERTO RICO', abbreviation: 'PR'},
                { name: 'RHODE ISLAND', abbreviation: 'RI'},
                { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
                { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
                { name: 'TENNESSEE', abbreviation: 'TN'},
                { name: 'TEXAS', abbreviation: 'TX'},
                { name: 'UTAH', abbreviation: 'UT'},
                { name: 'VERMONT', abbreviation: 'VT'},
                { name: 'VIRGIN ISLANDS', abbreviation: 'VI'},
                { name: 'VIRGINIA', abbreviation: 'VA'},
                { name: 'WASHINGTON', abbreviation: 'WA'},
                { name: 'WEST VIRGINIA', abbreviation: 'WV'},
                { name: 'WISCONSIN', abbreviation: 'WI'},
                { name: 'WYOMING', abbreviation: 'WY' }
            ],
            address: '',
        client : {
          first_name: "",
          last_name: "",
          is_exist: "",
          middle_name: '',
          email : '',
          is_email : false ,
          phone_h : '',
          phone_w : '',
          dob: '01-01-1950',
          ssn : '',
          phone_m : '',
          fax : '',
          address :'',
          
          address1: '',
          city : '',
          state : '',
          zip : '',
          country :'United States',
          memo : '',
          document : '',
          suffix:'',
          recaptcha: '',
          user_name: "",
          password: "",
          confirm_password: "",
          crc_id : ""

        },
        loadingUpload :false,
        otp_phone_input:"",
        isDark : true,
        validGeneral: true,
        isDisable : false,
        rules: [
                value => !!value || 'Required.',
            ],
        otp_email_input:"",
        year : new Date().getFullYear(),
        user_phone:'',
        user_email:'',
        verifyLoad: false,
        preview: '',
        verfiedFlag : false,
        verifyUser: '',
        loading : false,
        status:0,
        emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
        tab: null,
        headers: [

          { text: '', value: 'CompanyURL' },
          { text: '', value: 'CompanyName' },

        ],
        history: [

        ],

        setting: [
        ],

        items: [
              'Admin',
              'Viewer',
      ],
      select_role : 'Admin',
       sectors: [

      ],
      employeeNumber: [
              '10-50',
              '50-100',
              'More than 100',

      ],

      // Voice Agent Data
      voiceAgent: {
        has_voice_agent: false,
        retell_agent_id: null,
        retell_phone_number: null,
        voice_agent_enabled: false,
        voice_agent_prompt: null,
        voice_agent_created_at: null,
        voice_agent_updated_at: null
      },
      voiceAgentPrompt: '',
      voiceAgentLoading: false,
      phoneNumberLoading: false,
      promptLoading: false,
      clientVoiceFile: null,

      }
    },
    watch: {
      dob (val) {
        this.age = val ?  moment().diff(this.dob, 'years') :0
        console.log(this.age);
        if(isNaN(this.age))
          this.age = 0;
      },
    },
    methods: {
      getAddressData: function (addressData, placeResultData, id) {
            this.client.address = addressData.name;
            this.client.city = addressData.locality;
            this.client.state = addressData.administrative_area_level_1;
            this.client.zip = addressData.postal_code
            console.log(this.client);
        },
        dataURLtoFile(dataurl, filename) {
 
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], filename, {type:mime});
    },
         handleUploaded(cropper) {
          let image = cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime);
          let img = this.dataURLtoFile(image,'asdasd.jpg');
          let preview_url =process.env.VUE_APP_WASBI_URL;
          const data = new FormData();
        data.append('file', img);
        data.append('client_id', this.$route.params.id);
        this.loadingUpload = true;

        axios({
          method: "POST",
          url: "/api/upload-avatar",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')},
          data: data
          })
          .then(response => {
          Vue.$toast.success("Profile Picture uploaded", {
              position: 'top-right'
              });
              this.preview = preview_url+response.data.data;
              this.loadingUpload = false;

          })
          .catch(err => {
              Vue.$toast.error("Invalid file to upload", {
              position: 'top-right'
              });
              this.isDisableUpload = false;
              this.isDarkUpload = true;
          });

        },
    addPhone(){
        this.phoneFlag = 1;
    },
    addEmail(){
        this.emailFlag = 1;
    },
    countryChanged(country) {
        this.country = '+' + country.dialCode
    },
    verify(){
    let self = this;
    let flag = 1;
    if (!self.email && self.emailFlag ==1) {
    Vue.$toast.error('Email '+this.$t('questionnaire.questionnaire_alert_required'), {
        position: 'top-right'
    });
    this.$refs['email'].focus()
    flag = 0;
    }
    let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (reg.test(self.email) == false && flag == 1 && self.emailFlag == 1) {
        Vue.$toast.error('Invalid Email format', {
        position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
    }
    if (!self.phone && flag == 1 && self.phoneFlag == 1) {
    Vue.$toast.error('Phone Number '+this.$t('questionnaire.questionnaire_alert_required'), {
        position: 'top-right'
    });
    this.$refs['phone'].focus()
    flag = 0;
    }

    if (flag == 1) {
    var email = this.email;
    axios({
        method: "POST",
         
        url: "/api/auth/send_otp",
        data: {
        flag : self.phoneFlag == 1 ? 'phone' : 'email',
        email: self.email,
        phone:  self.phone,
        code: self.country,
        logged_flag : 1
        }
    })
        .then(response => {
        let data = response.data;
        if (data.data.flag == 1) {
            if(self.phoneFlag == 1 ){
                self.otp_phone = data.data.otp;
                self.phoneFlag = 2;
            }
            else{
                self.otp_email = data.data.otp;
                self.emailFlag = 2;
            }
            Vue.$toast.success(data.message, {
                position: 'top-right'
            });

        } else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }
        })
        .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
        });
      }
    },
    verifyOTP(){
        if(this.phoneFlag ==2){
            if(! this.otp_phone_input){
                Vue.$toast.error('OTP '+this.$t('questionnaire.questionnaire_alert_required'), {
                    position: 'top-right'
                });
            }else{
                if(this.otp_phone == this.otp_phone_input){
                    axios({
                        method: "POST",
                         
                        url: "/api/updateprofile",
                        data: {
                            flag: 'phone',
                            phone: this.phone,
                            code: this.country
                        }
                        })
                        .then(response => {
                            let data = response.data;
                            if (data.data == 1) {
                                Vue.$toast.success(data.message, {
                                    position: 'top-right'
                                })
                                this.getUserProfile()
                                this.phoneFlag = 3;
                            } else {
                                Vue.$toast.error(data.message, {
                                position: 'top-right'
                                });
                            }
                        })
                        .catch(err => {
                            Vue.$toast.error(err, {
                            position: 'top-right'
                            });
                        });


                }else{
                    Vue.$toast.error('Invalid OTP', {
                        position: 'top-right'
                    });
                    this.otp_phone_input ="";
                    this.$refs['phone_otp'].focus()
                }
            }

        }else{
            if(! this.otp_email_input){
                Vue.$toast.error('OTP '+this.$t('questionnaire.questionnaire_alert_required'), {
                    position: 'top-right'
                });
            }else{
                if(this.otp_email == this.otp_email_input){
                     axios({
                        method: "POST",
                         
                        url: "/api/updateprofile",
                        data: {
                            flag: 'email',
                            email: this.email,
                        }
                        })
                        .then(response => {
                            let data = response.data;
                            if (data.data == 1) {
                                Vue.$toast.success(data.message, {
                                    position: 'top-right'
                                })
                                //this.$router.push("/home");
                                this.emailFlag = 3;
                                this.getUserProfile()
                            } else {
                                Vue.$toast.error(data.message, {
                                position: 'top-right'
                                });
                            }
                        })
                        .catch(err => {
                            Vue.$toast.error(err, {
                            position: 'top-right'
                            });
                        });

                } else{
                    Vue.$toast.error('Invalid OTP', {
                        position: 'top-right'
                    });
                    this.otp_email_input ="";
                    this.$refs['email_otp'].focus()
                }
            }
        }
    },
    verifyCrc(){
            let self = this;
            let flag = 1;
            if (!this.client.crc_id) {
                Vue.$toast.error('Customer ID is required', {
                    position: 'top-right'
                });
                flag = 0;
            }else{
                self.verifyLoad = true;
                axios({
                method: "POST",
                 
                url: "/api/auth/verify-crc",
                data:{crc_id : self.client.crc_id},
                headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
                })
                .then(response => {
                    console.log(response);
                    if(response.data.data.success == 'True'){
                        self.verifyUser = response.data.data.result;
                        self.verfiedFlag = true;
                    }else{
                        Vue.$toast.error('Invalid customer id', {
                            position: 'top-right'
                        });
                    }
                    self.verifyLoad = false
                })
                .catch(err => {
                    // console.log(JSON.parse(err.response.data));
                    self.verifyLoad = flase;

                });
            }
        },
        autofill(){
            let self = this;
            self.client.first_name = self.verifyUser.firstname.toString()
            self.client.last_name = self.verifyUser.lastname.toString()
            self.client.email = self.verifyUser.email.toString()
            self.client.middle_name = self.verifyUser.middlename.toString()
            self.client.phone_m = self.verifyUser.phone_mobile.toString()
            self.client.phone_h = self.verifyUser.phone_home.toString()
            self.client.phone_w = self.verifyUser.phone_work.toString()
            self.client.ssn = self.verifyUser.ssno.toString()
            self.address = self.verifyUser.street_address.toString()
            if(self.verifyUser.state){
                self.stateOptions.forEach(element => {
                    if(self.verifyUser.state.toUpperCase()  == element.name)
                        self.client.state = element.abbreviation.toString()
                });
            }
            self.client.zip = self.verifyUser.zip.toString()
            self.client.city = self.verifyUser.city.toString()
            // console.log('suman',Array.isArray(self.verifyUser.birth_date));
            if(self.verifyUser.birth_date && !Array.isArray(self.verifyUser.birth_date)){
                self.dob = self.verifyUser.birth_date;
                
            }
            
        },
      changePassword: function () {
          let flag = 1;
          if (!this.password) {
            Vue.$toast.error('Password '+this.$t('questionnaire.questionnaire_alert_required'), {
                position: 'top-right'
            });
            this.$refs['password'].focus()
            flag = 0;
          }

          if (!this.confpassword) {
            Vue.$toast.error('Confirm Password '+this.$t('questionnaire.questionnaire_alert_required'), {
                position: 'top-right'
            });
            this.$refs['confpassword'].focus()
            flag = 0;
          }
          if (this.confpassword != this.password && flag == 1) {
            Vue.$toast.error('Confirm password did not match', {
                position: 'top-right'
            });
            self.$refs['conf_password'].focus()
            flag = 0;
        }

          if (flag == 1) {

            axios({
            method: "POST",
             
            url: "/api/passwordchange",
            data: {
            password: this.password,
            password_confirmation: this.confpassword,
          }
        })
          .then(response => {
            let data = response.data;
            if (data.data == 1) {
              Vue.$toast.success(this.$t('my_profile.profile_alert_password_change_successfull'), {
                position: 'top-right'
                });

            } else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          });
      } else {

      }

    },

    add: function () {
         // for setting tab
    },

    getUserProfile() {
    let flag = 1;
    let preview_url =process.env.VUE_APP_WASBI_URL;
    let header = { headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                }
        }
        let id  = this.$route.params.id;
      axios
        .get("/api/get-client/" + id,header)
        .then(response => {
            let data = response.data.data;

           if (flag == 1) {
            this.client = data;
            if(this.client.smart_credit_password)
                this.client.smart_credit_password = atob(this.client.smart_credit_password)
            if(this.client.my_free_score_password)
                this.client.my_free_score_password = atob(this.client.my_free_score_password);
            this.dob = data.dob
            this.address = data.address_1
            this.preview = data.avatar ?  preview_url + data.avatar : ''
            this.client.previous_address = data.previous_address ? JSON.parse(data.previous_address) : []
            this.client.checkbox_previous_address = this.client.previous_address.length > 0
            this.client.previous_employment = data.previous_employment ? JSON.parse(data.previous_employment) : []
            this.client.checkbox_previous_employment = this.client.previous_employment.length > 0
            }else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }

         })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });

     },

     addPreviousAddress(){
            this.client.previous_address.push({
                    address_1: '',
                    city: '',
                    state: '',
                    zip:'',
                    housing_type: '',
                    monthly_rent_mortgage_amount: '',
                    years_at_address: '',
                    months_at_address: '',
                })
        },
        removePreviousAddress(index){
            this.client.previous_address.splice(index, 1)
        },
        addPreviousEmployment(){
            this.client.previous_employment.push({
                employment_name: '',
                    employment_position: '',
                    employment_employer_phone: '',
                    employment_income:'',
                    employment_years_at_job: '',
                    employment_months_at_job: '',
                })
        },
        removePreviousEmployment(index){
            this.client.previous_employment.splice(index, 1)
        },


    saveProfile: function(e) {
      let self = this;
            let flag = 1;
          
            if (!this.client.first_name && flag == 1) {
                Vue.$toast.error('First Name is required', {
                    position: 'top-right'
                });
                flag = 0;
            }
            if (!this.client.last_name && flag == 1) {
                Vue.$toast.error('Last Name is required', {
                    position: 'top-right'
                });
                flag = 0;
            }
            if (!this.client.email && this.client.is_email == false && flag == 1) {
                Vue.$toast.error('Email is required', {
                    position: 'top-right'
                });
                flag = 0;
            }
            
            let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (reg.test(this.client.email) == false && this.client.is_email == false  && flag == 1) {
                Vue.$toast.error('Invalid email format', {
                    position: 'top-right'
                });
                flag = 0;
            }
            if (!this.client.phone_m && this.client.phone_m == false && flag == 1) {
                Vue.$toast.error('Phone (Mobile) is required', {
                    position: 'top-right'
                });
                flag = 0;
            }
            
            this.client.user_name = this.client.email;
            

        if (flag == 1) {
          this.loading = true;
          this.client.dob = this.dob;
          this.isDark = false;
          this.isDisable = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },
           
          url: "/api/edit-client/"+this.$route.params.id,
          data: self.client
        })
          .then(response => {
            let data = response.data;
            if (response.data) {
                  Vue.$toast.success('Client updated', {
                    position: 'top-right'
                  })
                  this.isDark = true;
                  this.loading =false
                  this.isDisable = false;

            } else {
                Vue.$toast.error('Failed To Add', {
                position: 'top-right'
                });
                this.loading =false
            }
          })
          .catch(err => {
            console.log(err.response);
              this.isDark = true;
              this.isDisable = false;
              this.client.dob = '';
              this.loading =false
              if(err.response.data){
                  let tmp = JSON.parse(err.response.data);
                if(tmp.email)
                  Vue.$toast.error(tmp.email[0], {
                  position: 'top-right'
                  });
                if(tmp.user_name)
                  Vue.$toast.error(tmp.user_name[0], {
                  position: 'top-right'
                  });  
              }else{
                Vue.$toast.error(err.response.data, {
                position: 'top-right'
                });      
              }
          });
        }
    },

    // Voice Agent Methods
    async loadVoiceAgentData() {
      try {
        const response = await axios.post('/api/voice-agent/get', {
          user_id: this.$route.params.id
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.voiceAgent = response.data.data;
          this.voiceAgentPrompt = this.voiceAgent.voice_agent_prompt || '';
          // Load client voice file
          this.loadClientVoiceFile();
        }
      } catch (error) {
        console.error('Error loading voice agent data:', error);
      }
    },

    // Client Voice File Methods
    async loadClientVoiceFile() {
      try {
        const clientId = this.$route.params.id;
        console.log('Loading voice file for client ID:', clientId);

        const response = await axios.post('/api/voice-agent/uploaded-voices', {}, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          console.log('All uploaded voices:', response.data.data);

          // Find voice file for this specific client (compare as strings)
          const clientVoice = response.data.data.find(voice =>
            String(voice.user_id) === String(clientId)
          );

          console.log('Found client voice:', clientVoice);
          this.clientVoiceFile = clientVoice || null;
        }
      } catch (error) {
        console.error('Error loading client voice file:', error);
        this.clientVoiceFile = null;
      }
    },

    async downloadClientVoice() {
      if (!this.clientVoiceFile) return;

      try {
        const response = await axios.post('/api/voice-agent/download-voice', {
          user_id: this.clientVoiceFile.user_id
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          },
          responseType: 'blob' // Important for file download
        });

        // Create blob URL and download
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.clientVoiceFile.voice_file_path.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success('Voice file downloaded successfully!');
      } catch (error) {
        console.error('Error downloading voice file:', error);
        this.$toast.error('Failed to download voice file');
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'Unknown';
      try {
        return new Date(dateString).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    },

    async createVoiceAgent() {
      this.voiceAgentLoading = true;
      try {
        const response = await axios.post('/api/voice-agent/create', {
          user_id: this.$route.params.id,
          voice_agent_prompt: this.voiceAgentPrompt
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.$toast.success('Voice agent created successfully', {
            position: 'top-right'
          });
          await this.loadVoiceAgentData();
        } else {
          this.$toast.error(response.data.message || 'Failed to create voice agent', {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error creating voice agent:', error);
        this.$toast.error('Error creating voice agent', {
          position: 'top-right'
        });
      } finally {
        this.voiceAgentLoading = false;
      }
    },

    async toggleVoiceAgent() {
      this.voiceAgentLoading = true;
      try {
        const response = await axios.post('/api/voice-agent/update', {
          user_id: this.$route.params.id,
          voice_agent_enabled: !this.voiceAgent.voice_agent_enabled
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.$toast.success('Voice agent status updated', {
            position: 'top-right'
          });
          await this.loadVoiceAgentData();
        } else {
          this.$toast.error(response.data.message || 'Failed to update voice agent', {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error updating voice agent:', error);
        this.$toast.error('Error updating voice agent', {
          position: 'top-right'
        });
      } finally {
        this.voiceAgentLoading = false;
      }
    },

    async assignPhoneNumber() {
      this.phoneNumberLoading = true;
      try {
        const response = await axios.post('/api/voice-agent/assign-phone', {
          user_id: this.$route.params.id
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.$toast.success('Phone number assigned successfully', {
            position: 'top-right'
          });
          await this.loadVoiceAgentData();
        } else {
          this.$toast.error(response.data.message || 'Failed to assign phone number', {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error assigning phone number:', error);
        this.$toast.error('Error assigning phone number', {
          position: 'top-right'
        });
      } finally {
        this.phoneNumberLoading = false;
      }
    },

    async updateVoiceAgentPrompt() {
      this.promptLoading = true;
      try {
        const response = await axios.post('/api/voice-agent/update', {
          user_id: this.$route.params.id,
          voice_agent_prompt: this.voiceAgentPrompt
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.$toast.success('Voice agent prompt updated', {
            position: 'top-right'
          });
          await this.loadVoiceAgentData();
        } else {
          this.$toast.error(response.data.message || 'Failed to update prompt', {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error updating prompt:', error);
        this.$toast.error('Error updating prompt', {
          position: 'top-right'
        });
      } finally {
        this.promptLoading = false;
      }
    },

    async deleteVoiceAgent() {
      if (!confirm('Are you sure you want to delete this voice agent? This action cannot be undone.')) {
        return;
      }

      this.voiceAgentLoading = true;
      try {
        const response = await axios.post('/api/voice-agent/delete', {
          user_id: this.$route.params.id
        }, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        });

        if (response.data.flag === 1) {
          this.$toast.success('Voice agent deleted successfully', {
            position: 'top-right'
          });
          await this.loadVoiceAgentData();
        } else {
          this.$toast.error(response.data.message || 'Failed to delete voice agent', {
            position: 'top-right'
          });
        }
      } catch (error) {
        console.error('Error deleting voice agent:', error);
        this.$toast.error('Error deleting voice agent', {
          position: 'top-right'
        });
      } finally {
        this.voiceAgentLoading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString();
    },

 },

created() {
      console.log('created called.');
      this.getUserProfile();
      this.loadVoiceAgentData();
      this.loadClientVoiceFile();
    },

}
</script>

